import { Routes, Route, Navigate } from 'react-router-dom'
import { useEffect } from 'react'
import { useAuthStore, useThemeStore } from './stores'
import { Layout } from './components/Layout'
import { ChatPage } from './views/chat/ChatPage'
import { UsersPage } from './views/users/UsersPage'
import { AttendancePage } from './views/attendance/AttendancePage'
import { PerformancePage } from './views/performance/PerformancePage'
import { LeavePage } from './views/leave/LeavePage'
import { DocumentsPage } from './views/documents/DocumentsPage'
import { EmployeesPage } from './views/employees/EmployeesPage'
import { LoginPage } from './views/LoginPage'
import { Toaster } from 'sonner'

function App() {
  const { isAuthenticated } = useAuthStore()
  const { theme } = useThemeStore()

  useEffect(() => {
    const root = document.documentElement
    if (theme === 'dark') {
      root.classList.add('dark')
    } else {
      root.classList.remove('dark')
    }
  }, [theme])

  if (!isAuthenticated) {
    return (
      <>
        <LoginPage />
        <Toaster position="top-center" />
      </>
    )
  }

  return (
    <>
      <Layout>
        <Routes>
          <Route path="/" element={<ChatPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/attendance" element={<AttendancePage />} />
          <Route path="/performance" element={<PerformancePage />} />
          <Route path="/leave" element={<LeavePage />} />
          <Route path="/documents" element={<DocumentsPage />} />
          <Route path="/employees" element={<EmployeesPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
      <Toaster position="top-center" />
    </>
  )
}

export default App
